export const enum trackingConstants {
    listSessionsRequest = "LIST_TRACKING_SESSIONS_REQUEST",
    listSessionsSuccess = "LIST_TRACKING_SESSIONS_SUCCESS",
    listSessionsFailure = "LIST_TRACKING_SESSIONS_FAILURE",

    viewSessionRequest = "VIEW_TRACKING_SESSION_REQUEST",
    viewSessionSuccess = "VIEW_TRACKING_SESSION_SUCCESS",
    viewSessionFailure = "VIEW_TRACKING_SESSION_FAILURE",

    getActiveSessionsRequest = "GET_ACTIVE_TRACKING_SESSIONS_REQUEST",
    getActiveSessionsSuccess = "GET_ACTIVE_TRACKING_SESSIONS_SUCCESS",
    getActiveSessionsFailure = "GET_ACTIVE_TRACKING_SESSIONS_FAILURE",

    getSessionByBatchTodayRequest = "GET_SESSION_BY_BATCH_TODAY_REQUEST",
    getSessionByBatchTodaySuccess = "GET_SESSION_BY_BATCH_TODAY_SUCCESS",
    getSessionByBatchTodayFailure = "GET_SESSION_BY_BATCH_TODAY_FAILURE",
    getSessionByBatchTodayReset = "GET_SESSION_BY_BATCH_TODAY_RESET",

    historyListRequest = "HISTORY_LIST_REQUEST",
    historyListSuccess = "HISTORY_LIST_SUCCESS",
    historyListFailure = "HISTORY_LIST_FAILURE",

    viewSessionStudentsRequest = "VIEW_SESSION_STUDENTS_REQUEST",
    viewSessionStudentsSuccess = "VIEW_SESSION_STUDENTS_SUCCESS",
    viewSessionStudentsFailure = "VIEW_SESSION_STUDENTS_FAILURE",

    // Location Share
    generateShareTokenRequest = "GENERATE_SHARE_TOKEN_REQUEST",
    generateShareTokenSuccess = "GENERATE_SHARE_TOKEN_SUCCESS",
    generateShareTokenFailure = "GENERATE_SHARE_TOKEN_FAILURE",
    generateShareTokenReset = "GENERATE_SHARE_TOKEN_RESET",

    disableShareRequest = "DISABLE_SHARE_REQUEST",
    disableShareSuccess = "DISABLE_SHARE_SUCCESS",
    disableShareFailure = "DISABLE_SHARE_FAILURE",
    disableShareReset = "DISABLE_SHARE_RESET",

    getShareStatusRequest = "GET_SHARE_STATUS_REQUEST",
    getShareStatusSuccess = "GET_SHARE_STATUS_SUCCESS",
    getShareStatusFailure = "GET_SHARE_STATUS_FAILURE",
    getShareStatusReset = "GET_SHARE_STATUS_RESET",
}
